import React from 'react';
import { CoveSupportContext } from './CoveSupportProvider';
import type { CoveSupportContextValue } from './CoveSupportProvider';

export function useCoveSupport(): CoveSupportContextValue {
  const context = React.useContext(CoveSupportContext);
  if (context === undefined) {
    throw new Error('useCoveSupport must be used within a CoveSupportProvider');
  }
  return context;
}
